import React, {useEffect} from "react";
import "./MoreProject.css";
import ProjMini from "./ProjMini";
import { Link } from "react-router-dom";

import AOS from "aos";
import "aos/dist/aos.css";

function MoreProject() {

  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);

  return (
    <div className="MoreProject">
      <div className="proj-head">
        <div className="proj-head-main">
          <h2 data-aos={"fade-up"} data-aos-delay="300">Other Noteworthy Projects</h2>
          <Link to="/archive/" className="archive" data-aos={"fade-up"} data-aos-delay="500">
            <a className="archive" >view the archive</a>
          </Link>
        </div>
      </div>

      <div className="project-grid">
        <ProjMini
          topic="Github Profile Finder - React JS"
          des="The project searches the displays the profile details, along with the the repositories and labels the profile hireable or non-hireable."
          tech="React JS Github API Material UI"
        />

        <ProjMini
          topic="Youtube User-Interface Clone - React JS"
          des="The project searches the displays the profile details, along with the the repositories and labels the profile hireable or non-hireable."
          tech="React JS Github API Material UI"
        />

        <ProjMini
          topic="The Movie DB Application - React JS"
          des="TMDB Movie App is a project built with React JS, which fetches data from the API and displays the data of the movie. "
          tech="React JS TMDB API Material UI"
        />

        <ProjMini
          topic="Google Map Clone Application"
          des="This Google Map Clone Project fetches Data from the Mapbox and displays a Realtime World Map with features similar to Google Maps. "
          tech="JS Mapbox API Geo-location API"
        />

        <ProjMini
          topic="Github Profile Finder - React JS"
          des="The project searches the displays the profile details, along with the the repositories and labels the profile hireable or non-hireable."
          tech="React JS Github API Material UI"
        />

        <ProjMini
          topic="Github Profile Finder - React JS"
          des="The project searches the displays the profile details, along with the the repositories and labels the profile hireable or non-hireable."
          tech="React JS Github API Material UI"
        />
      </div>
    </div>
  );
}

export default MoreProject;
